import { useContext } from 'react';
import { Helmet } from 'react-helmet';
import AppContext from 'AppContext';
import styled from 'styled-components';
import { Nav } from 'components/base/nav';
import Signups from 'components/pages/about/signup';
import Header from 'components/pages/homepage/homepageheader';
import Content from 'components/utilities/components/Content';
import HorizontalTimeline from 'components/utilities/components/HorizontalTimeline';
import { theme } from 'components/utilities/utils';
import Footer from 'components/views/FooterView';
import ProgramSection from 'components/views/ProgramSection';
import Subheader from 'components/views/Subheader';
import FaqComponent from 'components/views/faq';
import WorkshopsView from 'components/views/workshopsview';

const Section = styled.section`
  text-align: center;
  padding: 0px;
  max-width: 1280px;
`;

export default function Media() {
  const { content, programs } = useContext(AppContext);
  return (
    <Section>
      <Helmet>
        <title>Parkdale Centre for Innovation</title>
        <meta name="description" content="Media, Arts, News & Journalism" />
        <meta property="og:title" content="Parkdale Centre" />
        <meta property="og:image" content="images/previews/incubators.png" />
        <meta
          property="og:url"
          content="https://www.parkdaleinnovates.org/programs"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Media Lab, Journalism program, Podcast & video workshops, Parkdale Radio"
        />
        <meta
          property="og:description"
          content="Grow your idea, get traction, and scale your work at Parkdale Centre. You bring the motivation."
        />
        <meta property="og:image" content="images/previews/incubators.png" />
      </Helmet>
      <Header
        pageName="media"
        color={
          content.media.Headers['Header text background color'] ||
          theme.colors.white27
        }
        nav={<Nav />}
        showNavigation
        showLanguageSelector
      />
      <Subheader
        pageName="media"
        section="SubHeaders"
        lcolor2="red"
        rcolor1={theme.colors.white}
        borderleft={theme.colors.red5}
        borderright="transparent"
        background={theme.colors.black7}
      />
      <HorizontalTimeline
        pageName="media"
        listName="Timeline"
        titleName="Hero"
      />
      <WorkshopsView />
      <Content content={programs.media}>
        <ProgramSection
          color={content.media.Footer.ThemeColor}
          programName="media"
        />
      </Content>
      <FaqComponent pageName="media" />
      <Signups pageName="media" />
      <Footer pageName="media" />
    </Section>
  );
}
